module.exports = __webpack_public_path__ + "static/media/exclamation.fd723721.png";